<template>
  <div>
    <v-row class="d-flex">
      <v-col cols="12" md="4" class="pt-0 pb-0">
        <v-select
          v-model="rubrics"
          :items="rubricList"
          label="Rubriques"
          multiple
          chips
          small-chips
          deletable-chips
          outlined
          hide-details
          :menu-props="{ zIndex: 13 }"
        />
      </v-col>
      <v-col cols="12" md="4" class="pt-0 pb-0">
        <v-select
          v-model="siteIds"
          :items="siteList"
          label="Sites sources"
          multiple
          chips
          small-chips
          deletable-chips
          outlined
          hide-details
          :loading="loadingSites"
          :menu-props="{ zIndex: 13 }"
        />
      </v-col>
      <v-col cols="12" md="4" class="pt-0 pb-0">
        <date-filter store="editorial" periodType="past-and-today" />
      </v-col>
    </v-row>

    <v-row class="d-flex">
      <v-col cols="12" md="4" class="pt-0 pb-0">
        <v-select
          v-model="displayMode"
          :items="displayModeList"
          label="Affichage"
          outlined
          hide-details
          :menu-props="{ zIndex: 13 }"
        />
      </v-col>
      <v-col cols="12" md="8" class="d-flex pt-0 pb-0">
        <v-spacer />
        <apply-filters :disabled="isLoading" color="primary" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { computed, onMounted, ref } from "@vue/composition-api";

import ApplyFilters from "@/components/common/filters/ApplyFilters.vue";
import DateFilter from "@/components/common/filters/DateFilter.vue";

import useAxios from "@/hooks/useAxios";
import useProxy from "@/hooks/useProxy";

export default {
  name: "InternalSourcesFilters",
  components: {
    ApplyFilters,
    DateFilter,
  },
  setup() {
    const { store } = useProxy();
    const { axiosGet, isLoading } = useAxios();

    const rubricList = [
      { value: "cuisine", text: "Cuisine" },
      { value: "mode", text: "Mode" },
      { value: "beaute", text: "Beauté" },
      { value: "maison_deco", text: "Maison & Déco" },
    ];

    const displayModeList = [
      { value: "feed", text: "Fil d'actualité" },
      { value: "masonry", text: "Widget" },
      { value: "dataTable", text: "Tableau" },
    ];

    const siteList = ref([]);
    const loadingSites = ref(false);

    const rubrics = computed({
      get: () => store.getters["editorial/getRubrics"],
      set: (value) => store.dispatch("editorial/updateRubrics", value),
    });
    const siteIds = computed({
      get: () => store.getters["editorial/getSiteIds"],
      set: (value) => store.dispatch("editorial/updateSiteIds", value),
    });
    const displayMode = computed({
      get: () => store.getters["editorial/getDisplayMode"],
      set: (value) => store.dispatch("editorial/updateDisplayMode", value),
    });

    const fetchSites = async () => {
      try {
        loadingSites.value = true;
        const {
          data: { items },
        } = await axiosGet("/editorial/leparisien/sites", {});
        siteList.value = items.map((s) => ({
          value: s.site_id,
          text: `${s.name || "—"} (${s.nb})`,
        }));
      } catch (error) {
        console.error("error while fetching source sites");
      }
      loadingSites.value = false;
    };

    onMounted(fetchSites);

    return {
      rubricList,
      displayModeList,
      siteList,
      loadingSites,
      isLoading,
      rubrics,
      siteIds,
      displayMode,
    };
  },
};
</script>
